// import { formatNumber, getTooltipData } from "./index"; // Import helpers

// export default function ContentKeyMetrics({
//  validData,
//  previousValidData,
//  totalPosts,
//  prevTotalPosts,
//  totalReactions,
//  prevTotalReactions,
//  totalViews,
//  prevTotalViews,
//  currSpanDays,
//  prevSpanDays,
// }) {
// // -------------------------------------------------------
// // Content Metrics Calculations
// // -------------------------------------------------------
// // Total Views (NEW METRIC)
// const viewsChangePct = prevTotalViews
//  ? ((totalViews - prevTotalViews) / prevTotalViews) * 100
//  : 0;

// // Total Content
// const postChangePct = prevTotalPosts
//  ? ((totalPosts - prevTotalPosts) / prevTotalPosts) * 100
//  : 0;

// // Avg Engagement/Post
// const avgEngagementPerPost = totalPosts > 0 ? totalReactions / totalPosts : 0;
// const prevAvgEngagementPerPost =
//  prevTotalPosts > 0 ? prevTotalReactions / prevTotalPosts : 0;

// const avgEngagementPerPostChangePct = prevAvgEngagementPerPost
//  ? ((avgEngagementPerPost - prevAvgEngagementPerPost) / prevAvgEngagementPerPost) * 100
//  : 0;

// // Posting Frequency
// const postingFrequency = currSpanDays ? totalPosts / currSpanDays : 0;
// const prevPostingFrequency = prevSpanDays ? prevTotalPosts / prevSpanDays : 0;

// const postingFrequencyChangePct = prevPostingFrequency
//  ? ((postingFrequency - prevPostingFrequency) / prevPostingFrequency) * 100
//  : 0;

// // -------------------------------------------------------
// // Build Metric Cards
// // -------------------------------------------------------
// return [
//  // NEW CARD: Total Views
//  {
//   title: "Total Views",
//   color: "accent",
//   icon: "visibility", // Icon for views
//   count: formatNumber(totalViews),
//   fullCount: totalViews,
//   percentage: {
//    color: viewsChangePct >= 0 ? "success" : "error",
//    amount: `${viewsChangePct.toFixed(2)}%`,
//    tooltip: getTooltipData(totalViews, prevTotalViews, validData, previousValidData),
//   },
//  },
//  {
//   title: "Total Content",
//   color: "accent",
//   icon: "collections",
//   count: formatNumber(totalPosts),
//   fullCount: totalPosts,
//   percentage: {
//    color: postChangePct >= 0 ? "success" : "error",
//    amount: `${postChangePct.toFixed(2)}%`,
//    tooltip: getTooltipData(totalPosts, prevTotalPosts, validData, previousValidData),
//   },
//  },
//  {
//   title: "Content Growth (%)",
//   color: "accent",
//   icon: "show_chart",
//   count: `${postChangePct.toFixed(2)}%`,
//  },
//  {
//   title: "Avg Engagement/Post",
//   color: "accent",
//   icon: "insights",
//   count: formatNumber(avgEngagementPerPost),
//   fullCount: avgEngagementPerPost,
//   percentage: {
//    color: avgEngagementPerPostChangePct >= 0 ? "success" : "error",
//    amount: `${avgEngagementPerPostChangePct.toFixed(2)}%`,
//    tooltip: getTooltipData(
//     avgEngagementPerPost,
//     prevAvgEngagementPerPost,
//     validData,
//     previousValidData
//    ),
//   },
//  },
//  {
//   title: "Posting Frequency",
//   color: "accent",
//   icon: "schedule",
//   count: `${postingFrequency.toFixed(2)} / day`,
//   fullCount: postingFrequency,
//   percentage: {
//    color: postingFrequencyChangePct >= 0 ? "success" : "error",
//    amount: `${postingFrequencyChangePct.toFixed(2)}%`,
//    tooltip: getTooltipData(
//     postingFrequency,
//     prevPostingFrequency,
//     validData,
//     previousValidData
//    ),
//   },
//  },
// ];
// }

// ###########################################################

import { formatNumber, getTooltipData } from "./index"; // Import helpers

export default function ContentKeyMetrics({
    validData,
    previousValidData,
    totalPosts,
    prevTotalPosts,
    totalReactions,
    prevTotalReactions,
    totalViews,
    prevTotalViews,
    currSpanDays,
    prevSpanDays,
    // ⭐️ NEW PROPS FOR POST METRICS
    totalPostImpressions,
    prevTotalPostImpressions,
    totalPostReach,
    prevTotalPostReach,
}) {
    // -------------------------------------------------------
    // Content Metrics Calculations
    // -------------------------------------------------------
    // Total Views
    const viewsChangePct = prevTotalViews
        ? ((totalViews - prevTotalViews) / prevTotalViews) * 100
        : (totalViews > 0 ? 100 : 0);

    // ⭐️ Total Post Impressions Change
    const postImpressionsChangePct = prevTotalPostImpressions
        ? ((totalPostImpressions - prevTotalPostImpressions) / prevTotalPostImpressions) * 100
        : (totalPostImpressions > 0 ? 100 : 0);

    // ⭐️ Total Post Reach Change
    const postReachChangePct = prevTotalPostReach
        ? ((totalPostReach - prevTotalPostReach) / prevTotalPostReach) * 100
        : (totalPostReach > 0 ? 100 : 0);

    // Total Content
    const postChangePct = prevTotalPosts
        ? ((totalPosts - prevTotalPosts) / prevTotalPosts) * 100
        : 0;

    // Avg Engagement/Post
    const avgEngagementPerPost = totalPosts > 0 ? totalReactions / totalPosts : 0;
    const prevAvgEngagementPerPost =
        prevTotalPosts > 0 ? prevTotalReactions / prevTotalPosts : 0;

    const avgEngagementPerPostChangePct = prevAvgEngagementPerPost
        ? ((avgEngagementPerPost - prevAvgEngagementPerPost) / prevAvgEngagementPerPost) * 100
        : 0;

    // Posting Frequency
    const postingFrequency = currSpanDays ? totalPosts / currSpanDays : 0;
    const prevPostingFrequency = prevSpanDays ? prevTotalPosts / prevSpanDays : 0;

    const postingFrequencyChangePct = prevPostingFrequency
        ? ((postingFrequency - prevPostingFrequency) / prevPostingFrequency) * 100
        : 0;

    // -------------------------------------------------------
    // Build Metric Cards
    // -------------------------------------------------------
    return [
        // NEW CARD: Total Views (Exposure Metric 1)
        {
            title: "Total Video Views",
            color: "accent",
            icon: "visibility",
            count: formatNumber(totalViews),
            fullCount: totalViews,
            description: "Total number of times your video content was viewed.",
            percentage: {
                color: viewsChangePct >= 0 ? "success" : "error",
                amount: `${viewsChangePct.toFixed(2)}%`,
                tooltip: getTooltipData(totalViews, prevTotalViews, validData, previousValidData),
            },
        },
        // ⭐️ NEW CARD: Total Post Impressions (Exposure Metric 2)
        {
            title: "Total Post Views",
            color: "accent",
            icon: "trending_up",
            count: formatNumber(totalPostImpressions),
            fullCount: totalPostImpressions,
            description: "Total number of times your posts were viewed.",
            percentage: {
                color: postImpressionsChangePct >= 0 ? "success" : "error",
                amount: `${postImpressionsChangePct.toFixed(2)}%`,
                tooltip: getTooltipData(
                    totalPostImpressions,
                    prevTotalPostImpressions,
                    validData,
                    previousValidData
                ),
            },
        },
        // ⭐️ NEW CARD: Total Post Reach (Exposure Metric 3)
        {
            title: "Total Post Reach",
            color: "accent",
            icon: "public",
            count: formatNumber(totalPostReach),
            fullCount: totalPostReach,
            description: "Total number of unique people who saw your posts.",
            percentage: {
                color: postReachChangePct >= 0 ? "success" : "error",
                amount: `${postReachChangePct.toFixed(2)}%`,
                tooltip: getTooltipData(
                    totalPostReach,
                    prevTotalPostReach,
                    validData,
                    previousValidData
                ),
            },
        },
        // Total Content
        {
            title: "Total Content",
            color: "accent",
            icon: "collections",
            count: formatNumber(totalPosts),
            fullCount: totalPosts,
            description: "Total number of posts published in the selected period.",
            percentage: {
                color: postChangePct >= 0 ? "success" : "error",
                amount: `${postChangePct.toFixed(2)}%`,
                tooltip: getTooltipData(totalPosts, prevTotalPosts, validData, previousValidData),
            },
        },
        {
            title: "Content Growth (%)",
            color: "accent",
            icon: "show_chart",
            count: `${postChangePct.toFixed(2)}%`,
            description: "The percentage growth in content creation compared to previous period.",
        },
        {
            title: "Avg Engagement/Post",
            color: "accent",
            icon: "insights",
            count: formatNumber(avgEngagementPerPost),
            fullCount: avgEngagementPerPost,
            description: "Average engagement (likes, comments, etc) received per post.",
            percentage: {
                color: avgEngagementPerPostChangePct >= 0 ? "success" : "error",
                amount: `${avgEngagementPerPostChangePct.toFixed(2)}%`,
                tooltip: getTooltipData(
                    avgEngagementPerPost,
                    prevAvgEngagementPerPost,
                    validData,
                    previousValidData
                ),
            },
        },
        {
            title: "Posting Frequency",
            color: "accent",
            icon: "schedule",
            count: `${postingFrequency.toFixed(2)} / day`,
            fullCount: postingFrequency,
            description: "Average number of posts published per day.",
            percentage: {
                color: postingFrequencyChangePct >= 0 ? "success" : "error",
                amount: `${postingFrequencyChangePct.toFixed(2)}%`,
                tooltip: getTooltipData(
                    postingFrequency,
                    prevPostingFrequency,
                    validData,
                    previousValidData
                ),
            },
        },
    ];
}